interface CalculatorResultProps {
  label: string
  value: string
  highlight?: boolean
  subtext?: string
}

export function CalculatorResult({ label, value, highlight = false, subtext }: CalculatorResultProps) {
  return (
    <div className={`rounded-lg p-4 ${highlight ? 'border border-amber-500/30 bg-amber-500/10' : 'bg-muted/50'}`}>
      <div className="text-muted-foreground text-sm">{label}</div>
      <div className={`text-2xl font-bold ${highlight ? 'text-amber-500' : ''}`}>{value}</div>
      {subtext && <div className="text-muted-foreground mt-1 text-xs">{subtext}</div>}
    </div>
  )
}

interface CalculatorResultsGridProps {
  children: React.ReactNode
}

export function CalculatorResultsGrid({ children }: CalculatorResultsGridProps) {
  return <div className="grid grid-cols-2 gap-3">{children}</div>
}
